<template>
  <v-layout row justify-center>
    <v-dialog v-model="value.status" max-width="400">
      <v-card>
        <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field label="Note"
            v-model="note"
            placeholder="input here..."
            hide-details
            />
          </v-flex>
          <v-flex class="m-view-cst" xs12 lg4 v-for="item in value.actions.actionButton" :key="item">
            <v-btn
              @click="(item === 'REVISION' || item === 'REJECTED') && !noteFilled ? alertbtn() : actionsbtn(item)"
              dark
              block
              :color="item === 'REVISION'?'yellow darken-3':item === 'APPROVED'?'green darken-1':'red darken-1'">
            {{item}}
            </v-btn>
          </v-flex>
        </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import Vuex from 'vuex'

const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    note: '',
    message: 'Document has been approved'
  }),
  computed: {
    noteFilled () {
      return this.note.trim() !== ''
    }
  },
  methods: {
    ...dialogsStore.mapActions({
      showConfirmation: 'showConfirmation',
      closeConfirmation: 'closeConfirmation'
    }),
    actionsbtn (actions) {
      const self = this
      self.value.actions.content.approvalNote = self.note
      self.value.actions.content.approvalStatus = actions
      const success = (res) => {
        self.$setApprovalNotification({vueinstance: self, status: self, message: `Document has been ${actions.toLowerCase()}`})
        self.$showApprovalStatus({vueinstance: self, Status: false})
        self.$showApprovalData({vueinstance: self, data: []})
        self.$showApprovalAction({vueinstance: self, actions: []})
      }
      const reject = () => {
        self.$setApprovalNotification({vueinstance: self, status: true, message: `Something Error Contact Administrator`})
        self.$showApprovalStatus({vueinstance: self, Status: false})
        self.$showApprovalData({vueinstance: self, data: []})
        self.$showApprovalAction({vueinstance: self, actions: []})
      }
      const command = () => self.$backend.approval
        .approvalActionUsingPUT({id: self.value.actions.content.id, approval: self.value.actions.content})
        .then(res => success(res)).catch(() => reject())
      this.$emit('approval', {action: actions, note: this.note, command: command})
    },
    alertbtn () {
      this.showConfirmation({
        message: 'Note must be filled first!',
        title: 'Cannot continue',
        buttons: [{label: 'Ok', handler: () => this.closeConfirmation()}]
      })
    }
  }
}
</script>
<style scoped>
@media only screen and (max-width: 599px) {
  .m-view-cst{
    padding: 0px !important;
  }
}
.title{
  padding: 25px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialogs/ApprovalConfirmation.vue